import React, { Fragment, useEffect } from 'react'
import { logout } from '../../actions/auth'
import { connect } from 'react-redux'
import { getCurrentProfileTeacher } from '../../actions/profileTeacher'
import { getCurrentProfile } from '../../actions/profileStudent'
import NotLoggedInNav from './NotLoggedInNav'
import StudentLoggedInNav from './StudentLoggedInNav'
import TeacherLoggedInNav from './TeacherLoggedInNav'
import AdminLoggedInNav from './AdminLoggedInNav'
import { Cloudinary } from '@cloudinary/url-gen'

const Header = ({
  logout,
  getCurrentProfile,
  getCurrentProfileTeacher,
  auth: { user, isAuthenticated },
  profileStudent: { profile },
  profileTeacher: { profileTeacher },
}) => {
  const cld = new Cloudinary({
    cloud: {
      cloudName: 'youspeak',
    },
  })

  let cldStudentImageAvatar = ''
  if (profile && profile.imageAvatar) {
    const cldStudentAvatar = cld.image(profile.imageAvatar)
    cldStudentImageAvatar = cldStudentAvatar.toURL()
  }

  let cldTeacherImageAvatar = ''
  if (profileTeacher && profileTeacher.teacherAvatar) {
    const cldTeacherAvatar = cld.image(profileTeacher.teacherAvatar)
    cldTeacherImageAvatar = cldTeacherAvatar.toURL()
  }

  useEffect(() => {
    if (user && user.role === 'user') {
      getCurrentProfile()
    } else if (user && user.role === 'teacher') {
      getCurrentProfileTeacher()
    }
  }, [user, getCurrentProfile, getCurrentProfileTeacher])

  return (
    <Fragment>
      {isAuthenticated && user && user.role === 'user' ? (
        <StudentLoggedInNav
          user={user}
          profile={profile}
          logout={logout}
          cldStudentImageAvatar={cldStudentImageAvatar}
        />
      ) : isAuthenticated && user && user.role === 'teacher' ? (
        <TeacherLoggedInNav
          user={user}
          profileTeacher={profileTeacher}
          logout={logout}
          cldTeacherImageAvatar={cldTeacherImageAvatar}
        />
      ) : isAuthenticated && user && user.role === 'admin' ? <AdminLoggedInNav user={user} /> : (
        <NotLoggedInNav />
      )}
    </Fragment>
  )
}

const mapStateToProps = (state) => ({
  auth: state.auth,
  profileStudent: state.profileStudent,
  profileTeacher: state.profileTeacher,
})

export default connect(mapStateToProps, {
  logout,
  getCurrentProfile,
  getCurrentProfileTeacher,
})(Header)
